import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getSuppliers } from "../../services/supplierService";

const initialState = {
    adminSupplierDetails: [],
    isLoading: true,
    error: null,
    filteredChips: [],
    totals: {},
    page: 1,
    size: 10,
    hasMore: true
};

export const getAdminSuppliersApi = createAsyncThunk("adminSupplier/getAdminSuppliersApi", async ({ filteredData, page, size }) => {
    try {
        const response = await getSuppliers(filteredData, page, size);
        return response;
    } catch (error) {
        throw error;
    }
});

const adminSupplierSlice = createSlice({
    name: "adminSupplier",
    initialState,
    reducers: {
        setFilteredChips: (state, action) => {
            state.filteredChips = action.payload;
        },
        clearFilteredChips: (state) => {
            state.filteredChips = [];
        },
        resetAdminSupplierState: (state) => {
            Object.assign(state, initialState);
        },
        setPageSize: (state, action) => {
            state.size = action.payload;
        },
        setPage: (state, action) => {
            state.page = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getAdminSuppliersApi.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        });

        builder.addCase(getAdminSuppliersApi.fulfilled, (state, action) => {
            state.isLoading = false;
            // Handle different response structures
            const suppliersData = action.payload?.data?.data || action.payload?.data || action.payload || [];
            const transformedSuppliers = suppliersData.map(supplier => ({
                id: supplier.id,
                name: supplier.name,
                commission: supplier.commission_avg,
                country_id: supplier.country_id,
                country: supplier?.Country?.name || "",
                paymentsUSD: supplier.payments_usd || "0.00",
                paymentsLocalAmount: supplier.payments_local || "0.00",
                paymentsLocalCurrency: supplier.currency || "",
                consumedUSD: supplier.consumed_usd || "0.00",
                consumedLocalAmount: supplier.consumed_local || "0.00",
                consumedLocalCurrency: supplier.currency || "",
                balanceUSD: supplier.balance_usd || "0.00",
                balanceLocalAmount: supplier.balance_local || "0.00",
                balanceLocalCurrency: supplier.currency || "",
                balanceStatus: "text-success",
                thresholdUSD: supplier.threshold_usd || "0.00",
                thresholdLocalAmount: supplier.threshold_local || "0.00",
                thresholdLocalCurrency: supplier.currency || "",
                active: Number(supplier.status) == 1,
                validity: supplier.validity || "",
                critical_balance: supplier.critical_balance || "0.00",
                currency: supplier.currency || ""
            }));
            
            if (action.meta.arg.page === 1) {
                state.adminSupplierDetails = transformedSuppliers;
            } else {
                state.adminSupplierDetails = [...state.adminSupplierDetails, ...transformedSuppliers];
            }
            
            state.hasMore = suppliersData.length >= state.size;
            const totalPayments = state.adminSupplierDetails.reduce((sum, supplier) => 
                sum + parseFloat(supplier.paymentsUSD || 0), 0
            ).toFixed(2);
            const totalConsumed = state.adminSupplierDetails.reduce((sum, supplier) => 
                sum + parseFloat(supplier.consumedUSD || 0), 0
            ).toFixed(2);
            const totalBalance = state.adminSupplierDetails.reduce((sum, supplier) => 
                sum + (parseFloat(supplier.paymentsUSD || 0) - parseFloat(supplier.consumedUSD || 0)), 0
            ).toFixed(2);

            state.totals = { totalPayments, totalConsumed, totalBalance };
        });

        builder.addCase(getAdminSuppliersApi.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.error.message;
        });
    },

})

const { reducer } = adminSupplierSlice;
export const { setFilteredChips, clearFilteredChips, resetAdminSupplierState, setPageSize, setPage } = adminSupplierSlice.actions;
export default reducer;
